import 'react-toastify/dist/ReactToastify.css';

export const toastSuccess = (toast, successMessage, options) => {
    toast.success(successMessage, {
        className: 'toast-message',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        ...options,
    });
}

export const toastError = (toast, errorMessage, options) => {
    toast.error(errorMessage, {
        className: 'toast-message',
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        ...options,
    });
}

export const toastInfo = (toast, successMessage, options) => {
    toast.info(successMessage, {
        className: 'toast-message',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        ...options,
    });
}

export const toastWarning = (toast, warningMessage, options) => {
    toast.warning(warningMessage, {
        className: 'toast-message',
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        ...options,
    });
}
